module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-114x114-precomposed-719e3fbc716440a8f9232ae24d076d63.png";